module.exports = __webpack_public_path__ + "media/01.bffffaa8.mp3";